class OutputDeviceModel {
    constructor(outputDevice) {
        const { outDevId } = outputDevice;
        this.label = outDevId;
        this.value = outDevId;
    }
}

export default OutputDeviceModel;